import { FrameTextual } from "@fyendalscollection/marketing/lib/components/FrameTextual";
import { PageHome } from "@fyendalscollection/marketing/pages/PageHome";
import { PageLegalDisclaimer } from "@fyendalscollection/marketing/pages/PageLegalDisclaimer";
import { PagePrivacyPolicy } from "@fyendalscollection/marketing/pages/PagePrivacyPolicy";
import { PageTermsAndConditions } from "@fyendalscollection/marketing/pages/PageTermsAndConditions";
import { PageTermsOfService } from "@fyendalscollection/marketing/pages/PageTermsOfService";
import { Route, Routes } from "react-router-dom";

export const Router = (): JSX.Element => {
	return (
		<Routes>
			<Route index element={<PageHome />} />
			<Route path="terms-and-conditions" element={<FrameTextual />}>
				<Route index element={<PageTermsAndConditions />} />
			</Route>
			<Route path="privacy-policy" element={<FrameTextual />}>
				<Route index element={<PagePrivacyPolicy />} />
			</Route>
			<Route path="legal-disclaimer" element={<FrameTextual />}>
				<Route index element={<PageLegalDisclaimer />} />
			</Route>
			<Route path="terms-of-service" element={<FrameTextual />}>
				<Route index element={<PageTermsOfService />} />
			</Route>
		</Routes>
	);
};
